import { useContext } from "react";
import { LeftNavbarVisibleContext } from "../LeftNavbarVisibleContext";

export function useIsLeftNavbarVisible() {
  const { isLeftNavbarVisible, setIsLeftNavbarVisible } = useContext(LeftNavbarVisibleContext);

  return { isLeftNavbarVisible, setIsLeftNavbarVisible };
}
